export const cleanStringInput = (input) => {
    if (input) {
        return input;
    } else if (input === 0) {
        return input;
    } else {
        return '';
    }
};